import { useEffect, useState } from "react";

export default function DateTime() {
  const [time, setTime] = useState("");
  const [month, setMonth] = useState("");
  const [day, setDay] = useState("");

  useEffect(() => {
    const timeFormatter = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    const monthFormatter = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
      month: "long",
    });

    const dayFormatter = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
      day: "numeric",
    });

    const update = () => {
      const now = new Date();
      setTime(timeFormatter.format(now));
      setMonth(monthFormatter.format(now));
      setDay(dayFormatter.format(now));
    };

    update(); // run immediately
    const interval = setInterval(update, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <span className="text-white font-light text-sm select-none flex items-center gap-3">
      <span>{time}</span>
      <span className="flex items-center gap-1">
        <span>{day}</span>
        <span>{month}</span>
      </span>
    </span>
  );
}